import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { dispatch } from "../index";

const initialState = {
  error: null,
  workout: [],
  food: [],
  loading: false,
};

const slice = createSlice({
  name: "covers",
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    startLoading(state) {
      state.loading = true;
    },
    stopLoading(state) {
      state.loading = false;
    },
    getSuccess(state, action) {
      const all = Array.isArray(action.payload) ? action.payload : [];
      const byOrder = (a, b) => (a.order || 0) - (b.order || 0);
      state.workout = all.filter((c) => c.type === "workout").sort(byOrder);
      state.food = all.filter((c) => c.type === "food").sort(byOrder);
      state.loading = false;
    },
  },
});

export default slice.reducer;

export function getCovers() {
  return async () => {
    try {
      const result = await axios.get(`/covers/admin/all`);
      dispatch(slice.actions.getSuccess(result.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addCover({ type, image_id, description, order }) {
  return async () => {
    try {
      await axios.post(`/covers`, { type, image_id, description, order });
      dispatch(getCovers());
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function editCover(id, { description, order }) {
  return async () => {
    try {
      await axios.put(`/covers/${id}`, { description, order });
      dispatch(getCovers());
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// Persist a new display order for one type's covers. Sends each cover's current
// description alongside the new order index — the backend PUT sets description
// unconditionally, so omitting it would null it out. Refetches once at the end.
export function reorderCovers(orderedCovers = []) {
  return async () => {
    try {
      await Promise.all(
        orderedCovers.map((c, index) =>
          axios.put(`/covers/${c.id}`, { description: c.description ?? "", order: index })
        )
      );
      dispatch(getCovers());
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// Set (or clear, when imageId is empty) the per-language localised image for one
// cover. The base image stays the fallback. Refetches so the panel reflects the
// new image_localisation map.
export function localiseCover(id, languageId, imageId) {
  return async () => {
    try {
      await axios.post(`/covers/${id}/localise-image`, { languageId, imageId: imageId || "" });
      dispatch(getCovers());
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteCover(id) {
  return async () => {
    try {
      await axios.delete(`/covers/${id}`);
      dispatch(getCovers());
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
